import { globalFetch } from './globalActions';
import { ADVERTS_HAS_ERRORED, ADVERTS_IS_LOADING, ADVERTS_STING_SERIES_FETCH_DATA_SUCCESS, ADVERTS_STING_PROGRAMME_FETCH_DATA_SUCCESS, ADVERTS_DISABLE_FETCH_DATA_SUCCESS, ADVERTS_STING_CAT_FETCH_DATA_SUCCESS } from './types';

///////////
// Adverts Feeds //
///////////

export function fetchAdverts() {
	return globalFetch({
			urlPath: `stings`,
			urlSrc: 1,
			reducerIsLoading: ADVERTS_IS_LOADING,
			reducerError: ADVERTS_HAS_ERRORED,
			dispatchSuccess: (itemObj, dispatch) => {
				dispatch({ type: ADVERTS_STING_SERIES_FETCH_DATA_SUCCESS, items: itemObj.advertStings.series_id });
				dispatch({ type: ADVERTS_STING_PROGRAMME_FETCH_DATA_SUCCESS, items: itemObj.advertStings.programme_id });
				dispatch({ type: ADVERTS_STING_CAT_FETCH_DATA_SUCCESS, items: itemObj.advertStings.cat_id });
				dispatch({ type: ADVERTS_DISABLE_FETCH_DATA_SUCCESS, items: itemObj.advertDisableWeb });
			}
	});
}
